var map = {
	"./Amex.svg": "c6eb",
	"./Amex3.svg": "b520",
	"./Diners.svg": "e6eb",
	"./Elo.svg": "a948",
	"./MasterCard.svg": "3218",
	"./VOUCHER.svg": "e9d2",
	"./Visa.svg": "fef7",
	"./account-check.svg": "9736",
	"./alelo.svg": "19ad",
	"./anniversary.svg": "6ae4",
	"./bill.svg": "711f",
	"./calendar-empty-ultrathin-page.svg": "525b",
	"./commentsign.svg": "22dd",
	"./deliveryscooter.svg": "0978",
	"./eattake-horizontal-colorida.svg": "dbfc",
	"./eattake-vertical-colorida-svg.svg": "0632",
	"./enablelocation.svg": "bfcc",
	"./giftbag.svg": "1af0",
	"./hourglass.svg": "7233",
	"./location-pin.svg": "ed2b",
	"./paperplane.svg": "b833",
	"./pix.svg": "3090",
	"./place.svg": "1251",
	"./qrcode.svg": "2a97",
	"./shop.svg": "5cb7",
	"./sodexo-logo-simple.svg": "1004",
	"./sodexo.svg": "833a",
	"./tap.svg": "fd0d",
	"./undefined.svg": "4db1",
	"./vr.svg": "6979",
	"./zeedhi_new_logo.svg": "f27f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";